import React from "react";
import "../../../css/Terms.css";
import { Default } from "../../layouts/default";
import { Link } from "react-router-dom";

function ReturnRefund() {
  return (
    <Default>
      <section className="Return-Refund">
        <div className="container">
          <div className="row">
            <div className="col-md-10">
              <h1 className="Terms-Heading">Return and Refund Policy</h1>
              <p className="Para-Terms">Last updated: January 01, 2024</p>
              <p className="Para-Terms">
                Thank you for shopping at bookvenue.app.
              </p>
              <p className="Para-Terms">
                If, for any reason, You are not completely satisfied with a
                purchase We invite You to review our policy on refunds and
                returns.
              </p>
              <p className="Para-Terms">
                The following terms are applicable for any products that You
                purchased with Us.
              </p>
              <h2 className="Terms-twoHeading">Interpretation & Definitions</h2>
              <h3 className="Privacy-three">Interpretation</h3>
              <p className="Para-Terms">
                The words of which the initial letter is capitalized have
                meanings defined under the following conditions. The following
                definitions shall have the same meaning regardless of whether
                they appear in singular or in plural.
              </p>
              <h3 className="Privacy-three">Definitions</h3>
              <p className="Para-Terms">
                For the purposes of this Return and Refund Policy:
              </p>
              <ul>
                <li>
                  <p className="Para-Terms">
                    <strong>Company</strong> (referred to as either &quot;the
                    Company&quot;, &quot;We&quot;, &quot;Us&quot; or
                    &quot;Our&quot; in this Agreement) refers to bookvenue.app.
                  </p>
                </li>
                <li>
                  <p className="Para-Terms">
                    <strong>Goods</strong> refer to the items offered for sale
                    on the Service.
                  </p>
                </li>
                <li>
                  <p className="Para-Terms">
                    <strong>Orders</strong> mean a request by You to purchase
                    Goods from Us.
                  </p>
                </li>
                <li>
                  <p className="Para-Terms">
                    <strong>Service</strong> refers to the Website.
                  </p>
                </li>
                <li>
                  <p className="Para-Terms">
                    <strong>Website</strong> refers to bookvenue.app, accessible
                    from{" "}
                    <Link
                      to="https://bookvenue.app"
                      rel="external nofollow noopener"
                      target="_blank"
                    >
                      https://bookvenue.app
                    </Link>
                  </p>
                </li>
                <li>
                  <p className="Para-Terms">
                    <strong>You</strong> means the individual accessing or using
                    the Service, or the company, or other legal entity on behalf
                    of which such individual is accessing or using the Service,
                    as applicable.
                  </p>
                </li>
              </ul>
              <h2 className="Terms-twoHeading">
                Your Order Cancellation Rights
              </h2>
              <p className="Para-Terms">
                You are entitled to cancel Your Order within 7 days without
                giving any reason for doing so.
              </p>
              <p className="Para-Terms">
                The deadline for cancelling an Order is 7 days from the date on
                which You received the Goods or on which a third party you have
                appointed, who is not the carrier, takes possession of the
                product delivered.
              </p>
              <p className="Para-Terms">
                In order to exercise Your right of cancellation, You must inform
                Us of your decision by means of a clear statement. You can
                inform us of your decision by:
              </p>
              <ul>
                <li>
                  <p className="Para-Terms">
                    By email: mailto:admin@giksindia.com
                  </p>
                </li>
                <li>
                  <p className="Para-Terms">
                    By visiting this page on our website:{" "}
                    <Link
                      to="https://bookvenue.app/contact"
                      rel="external nofollow noopener"
                      target="_blank"
                    >
                      https://bookvenue.app/contact-us
                    </Link>
                  </p>
                </li>
              </ul>
              <p className="Para-Terms">
                We will reimburse You no later than 14 days from the day on
                which We receive the returned Goods. We will use the same means
                of payment as You used for the Order, and You will not incur any
                fees for such reimbursement.
              </p>
              <h2 className="Terms-twoHeading">Conditions for Returns</h2>
              <p className="Para-Terms">
                In order for the Goods to be eligible for a return, please make
                sure that:
                {/* 
                
                 */}
              </p>
              <ul>
                <li className="list-Terms">
                  The Goods were purchased in the last 7 days
                </li>
                <li className="list-Terms">
                  The Goods are in the original packaging
                </li>
              </ul>
              <p className="Para-Terms">
                The following Goods cannot be returned:
              </p>
              <ul>
                <li className="list-Terms">
                  The supply of Goods made to Your specifications or clearly
                  personalized.
                </li>
                <li className="list-Terms">
                  The supply of Goods which according to their nature are not
                  suitable to be returned, deteriorate rapidly or where the date
                  of expiry is over.
                </li>
                <li className="list-Terms">
                  The supply of Goods which are not suitable for return due to
                  health protection or hygiene reasons and were unsealed after
                  delivery.
                </li>
                <li className="list-Terms">
                  The supply of Goods which are, after delivery, according to
                  their nature, inseparably mixed with other items.
                </li>
              </ul>
              <p className="Para-Terms">
                We reserve the right to refuse returns of any merchandise that
                does not meet the above return conditions in our sole
                discretion.
              </p>
              <p className="Para-Terms">
                Only regular priced Goods may be refunded. Unfortunately, Goods
                on sale cannot be refunded. This exclusion may not apply to You
                if it is not permitted by applicable law.
              </p>
              <h2 className="Terms-twoHeading">Returning Goods</h2>
              <p className="Para-Terms">
                You are responsible for the cost and risk of returning the Goods
                to Us. You should send the Goods at the following address:
              </p>
              <p className="Para-Terms">
                bookvenue
                <br />
                Uttarakhand, 248001
                <br />
                INDIA
              </p>
              <p className="Para-Terms">
                We cannot be held responsible for Goods damaged or lost in
                return shipment. Therefore, We recommend an insured and
                trackable mail service. We are unable to issue a refund without
                actual receipt of the Goods or proof of received return
                delivery.
              </p>
              <h2 className="Terms-twoHeading">Gifts</h2>
              <p className="Para-Terms">
                If the Goods were marked as a gift when purchased and then
                shipped directly to you, You'll receive a gift credit for the
                value of your return. Once the returned product is received, a
                gift certificate will be mailed to You.
              </p>
              <p className="Para-Terms">
                If the Goods weren't marked as a gift when purchased, or the
                gift giver had the Order shipped to themselves to give it to You
                later, We will send the refund to the gift giver.
              </p>
              <h3 className="Privacy-three">Contact Us</h3>
              <p className="Para-Terms">
                If you have any questions about our Returns and Refunds Policy,
                please contact us:
              </p>
              <ul>
                <li>
                  <p className="Para-Terms">
                    By email: mailto:admin@giksindia.com
                  </p>
                </li>
                <li>
                  <p className="Para-Terms">
                    By visiting this page on our website:{" "}
                    <Link
                      to="https://bookvenue.app/contact"
                      rel="external nofollow noopener"
                      target="_blank"
                    >
                      https://bookvenue.app/contact-us
                    </Link>
                  </p>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>
    </Default>
  );
}

export default ReturnRefund;
